var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"padding-bottom":"10px"}},_vm._l((_vm.sheetList),function(item,index){return _c('p',{key:index,staticClass:"item"},[_vm._v(_vm._s(item))])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }